import React, { useCallback, useMemo, useState } from "react";
import CustomBreadcumbs from "../../../../component/atoms/custom-breadcumbs";
import TitlePages from "../../../../component/atoms/title-pages";
import { IconFilterReport } from "../../../../asset";
import DrawerReportDeliveryAssociate from "./__components/drawer";
import TableReportOrderNoData from "../report-order/__components/table/table-report-order-no-data";
import { useSelector } from "react-redux";
import { POSTGetListReportServices } from "../../../../service/POSTGetListReport";
import {
  LIST_DELIVERY_ASSOCIATE_REPORT,
  EXPORT_DELIVERY_ASSOCIATE_REPORT,
} from "../../../../api/contractAPI.api";
import { message } from "antd";
import TableDeliveryAssociateReportWithData from "./__components/table-report";
import { doExport } from "../../../../api/baseAPI";

const MainReportDeliveryAssociate = () => {
  const { token } = useSelector((state) => state.auth);
  const { globalDepotName, globalDeliveryAssociate } = useSelector(
    (state) => state.globalMSS
  );
  const { globalDDLDatePeriod } = useSelector((state) => state.globalDDL);
  const {
    valuesMultipleSelectDeliveryAssociateStatus,
    valuesMultipleSelectDriverType,
    valuesMultipleSelectVehicleOwnership,
  } = useSelector((state) => state.globalMultipleSelectValues);

  const [isDrawerOpened, setIsDrawerOpened] = useState(false);

  const [listData, setListData] = useState([]);
  const [bodyRequest, setBodyRequest] = useState();

  const onClickFilter = useCallback(() => {
    setIsDrawerOpened(true);
  }, []);

  const onCloseFilter = useCallback(() => {
    setIsDrawerOpened(false);
  }, []);

  const getListDeliveryAssociateReport = useCallback(
    async (payload) => {
      const res = await POSTGetListReportServices(
        token,
        LIST_DELIVERY_ASSOCIATE_REPORT,
        payload
      );
      if (res?.success) {
        setListData(res?.list);
      } else {
        if (res?.errorCode === 500) {
          message.error(res?.message);
        }
      }
      onCloseFilter();
    },
    [onCloseFilter, token]
  );

  const onApplyFilter = useCallback(async () => {
    const Depots = [...globalDepotName];
    const datePeriod = globalDDLDatePeriod;
    const DAStatus = [...valuesMultipleSelectDeliveryAssociateStatus];
    const DriverType = [...valuesMultipleSelectDriverType];
    const vehicleOwnership = [...valuesMultipleSelectVehicleOwnership];
    const deliveryAssociate = [...globalDeliveryAssociate];

    const depotList =
      Depots && Depots.length === 0
        ? { depot: { list_id: [], exclude: false } }
        : Depots && Depots.includes(-1)
        ? { depot: { list_id: [-1], exclude: false } }
        : {
            depot: {
              list_id: Depots.map((el) => el?.id),
              exclude: false,
            },
          };

    const payloadDatePeriod = { ...datePeriod };

    const DAStatusList =
      DAStatus && DAStatus.length === 0
        ? { delivery_associate_status: { list: [], exclude: false } }
        : DAStatus && DAStatus.includes(-1)
        ? {
            delivery_associate_status: {
              list: ["Active", "Expired"],
              exclude: false,
            },
          }
        : {
            delivery_associate_status: {
              list: DAStatus.map((el) => el?.id),
              exclude: false,
            },
          };

    const DriverTypeList =
      DriverType && DriverType.length === 0
        ? { driver_type: { list: [], exclude: false } }
        : DriverType && DriverType.includes(-1)
        ? {
            driver_type: {
              list: ["Owned", "Outsource"],
              exclude: false,
            },
          }
        : {
            driver_type: {
              list: DriverType.map((el) => el?.id),
              exclude: false,
            },
          };

    const vehicleOwnershipList =
      vehicleOwnership && vehicleOwnership.length === 0
        ? { vehicle_ownership: { list: [], exclude: false } }
        : vehicleOwnership && vehicleOwnership.includes(-1)
        ? {
            vehicle_ownership: {
              list: ["Owned", "Outsource"],
              exclude: false,
            },
          }
        : {
            vehicle_ownership: {
              list: vehicleOwnership.map((el) => el?.id),
              exclude: false,
            },
          };

    const deliveryAssociateList =
      deliveryAssociate && deliveryAssociate.length === 0
        ? { delivery_associate: { list_id: [], exclude: false } }
        : deliveryAssociate && deliveryAssociate.includes(-1)
        ? {
            delivery_associate: {
              list_id: [-1],
              exclude: false,
            },
          }
        : {
            delivery_associate: {
              list_id: deliveryAssociate.map((el) => el?.id),
              exclude: false,
            },
          };

    const bodyReq = {
      page: 1,
      limit: 10,
      order: "",
      filter: "",
      connector: "",
      other: {
        filter_selection: {
          ...depotList,
          period_date: {
            ...payloadDatePeriod,
          },
          ...DAStatusList,
          ...DriverTypeList,
          ...vehicleOwnershipList,
          ...deliveryAssociateList,
        },
      },
    };
    setBodyRequest(bodyReq);
    await getListDeliveryAssociateReport(bodyReq);
  }, [
    getListDeliveryAssociateReport,
    globalDDLDatePeriod,
    globalDeliveryAssociate,
    globalDepotName,
    valuesMultipleSelectDeliveryAssociateStatus,
    valuesMultipleSelectDriverType,
    valuesMultipleSelectVehicleOwnership,
  ]);

  const isBtnExportEnabled = useMemo(() => {
    if (listData && listData.length === 0) {
      return false;
    }
    return true;
  }, [listData]);

  const actionExportData = useCallback(async () => {
    const { filter_selection } = bodyRequest?.other;
    const payload = {
      filter_selection,
    };

    try {
      const res = await doExport(
        EXPORT_DELIVERY_ASSOCIATE_REPORT,
        token,
        payload
      );
      if (res?.status === 200) {
        const pdfBlob = new Blob([res?.data]);

        const url = window.URL.createObjectURL(pdfBlob);

        const tempLink = document.createElement("a");
        tempLink.href = url;
        tempLink.setAttribute("download", `report_delivery_associate.pdf`);

        document.body.appendChild(tempLink);
        tempLink.click();

        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(url);
        return;
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        // setIsFailedModalOpen(true);
        // setMessageFailed(error?.message);
        return;
      }
      if (error?.response?.status === 500) {
        message.error("Internal Server Error");
        return;
      }
    }
  }, [bodyRequest?.other, token]);

  return (
    <>
      <CustomBreadcumbs
        jmlLevel={2}
        menuLevel1={"Report"}
        menuLevel2={"Delivery Associate Report"}
      />
      <TitlePages name={"Delivery Associate Report"} />
      <div className="flex justify-between mt-5">
        <button
          className={`${
            isBtnExportEnabled ? "btn-export-enabled" : "btn-export-disabled"
          }`}
          onClick={isBtnExportEnabled ? () => actionExportData() : undefined}
        >
          Export
        </button>
        <button className="container-btn-filter-report" onClick={onClickFilter}>
          <span className="span-btn-filter-report">Filter</span>
          <img src={IconFilterReport} alt="icon-filter-report" />
        </button>
      </div>
      <div className="container-pages-table">
        {listData?.data?.length > 0 ? (
          <TableDeliveryAssociateReportWithData data={listData} />
        ) : (
          <>
            <TableReportOrderNoData openFilter={onClickFilter} />
          </>
        )}
      </div>
      <DrawerReportDeliveryAssociate
        onClose={onCloseFilter}
        open={isDrawerOpened}
        applyFilter={onApplyFilter}
      />
    </>
  );
};

export default MainReportDeliveryAssociate;
